import React from 'react';
import FeatureTile from '../FeatureTile';
import { useTileData } from '../../../hooks/useTileData';
import { getCdpKpis } from '../../../api';
import { fmtNumber } from '../../shared/format';

const Icon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

export default function VisitorIntelligenceTile({ clientId, rangeStart, rangeEnd }) {
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getCdpKpis(clientId, rangeStart, rangeEnd);
      return resp?.data ?? null;
    },
    [clientId, rangeStart, rangeEnd],
    Boolean(clientId && rangeStart && rangeEnd),
  );

  const cur = data?.current;
  const visitors = Number(cur?.total_visitors ?? 0);
  const known = Number(cur?.known_people ?? 0);
  const knownPct = visitors > 0 ? (known / visitors) * 100 : 0;

  const primary = cur ? {
    value: fmtNumber(visitors),
    label: 'Unique visitors',
    subtitle: `${fmtNumber(cur.total_sessions ?? 0)} sessions`,
  } : null;
  const secondary = cur ? [
    { value: fmtNumber(known), label: 'Known people' },
    { value: `${knownPct.toFixed(1)}%`, label: 'Identified' },
  ] : [];

  return (
    <FeatureTile
      title="Visitor Intelligence"
      icon={<Icon />}
      color="teal"
      primary={primary}
      secondary={secondary}
      ctaLabel="Open"
      ctaTo="/visitors"
      loading={loading}
      error={error}
    />
  );
}
